import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './authentication/login/login.component';
import { ResetPasswordComponent } from './authentication/reset-password/reset-password.component';
import { SignUpComponent } from './authentication/sign-up/sign-up.component';
import { RouteGuard } from './data-models/route-guard.model';
import { DevComponent } from './dev/dev.component';
import { ActiveTripHomeComponent } from './home/active-trip-home/active-trip-home.component';
import { NoTripHomeComponent } from './home/no-trip-home/no-trip-home.component';
import { FisheryNoticesComponent } from './menu-items/fishery-notices/fishery-notices.component';
import { ProfileComponent } from './menu-items/profile/profile.component';
import { RecordsPageComponent } from './menu-items/records-page/records-page.component';
import { ResourcesComponent } from './menu-items/resources/resources.component';
import { CancelReportComponent } from './reports/cancel-report/cancel-report.component';
import { GillNetReportComponent } from './reports/catch-reports/gill-net-report/gill-net-report.component';
import { SeineReportComponent } from './reports/catch-reports/seine-report/seine-report.component';
import { TrollReportComponent } from './reports/catch-reports/troll-report/troll-report.component';
import { EndReportComponent } from './reports/end-report/end-report.component';
import { OffloadReportComponent } from './reports/offload-report/offload-report.component';
import { PauseReportComponent } from './reports/pause-report/pause-report.component';
import { StartReportComponent } from './reports/start-report/start-report.component';
import { SpeciesAtRiskReportComponent } from './reports/species-at-risk-report/species-at-risk-report.component';
import { SubmissionPage } from './reports/submission-page/submission-page.component';
import { LostRecoveredGearFormComponent } from './reports/lost-recovered-gear-form/lost-recovered-gear-form.component';
import { MarineMammalInteractionFormComponent } from './reports/marine-mammal-interaction-form/marine-mammal-interaction-form.component';
import { AdminPanelComponent } from './admin-panel/admin-panel.component';
import { HelpComponent } from './menu-items/help/help.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent }, // does not need route guards
  { path: 'sign-up', component: SignUpComponent }, // does not need route guards
  { path: 'reset-password', component: ResetPasswordComponent }, // does not need route guards
  { path: 'resources', component: ResourcesComponent }, // does not need route guards
  { path: 'help', component: HelpComponent }, // does not need route guards
  { path: 'start-report/:id', component: StartReportComponent, canActivate: [RouteGuard] },
  { path: 'end-report/:id', component: EndReportComponent, canActivate: [RouteGuard] },
  { path: 'pause-report/:id', component: PauseReportComponent, canActivate: [RouteGuard] },
  { path: 'cancel-report', component: CancelReportComponent, canActivate: [RouteGuard] },
  { path: 'offload-report/:id', component: OffloadReportComponent, canActivate: [RouteGuard] },
  { path: 'submission-page', component: SubmissionPage, canActivate: [RouteGuard] },
  { path: 'gill-net-report/:id', component: GillNetReportComponent, canActivate: [RouteGuard] },
  { path: 'seine-report/:id', component: SeineReportComponent, canActivate: [RouteGuard] }, 
  { path: 'troll-report/:id', component: TrollReportComponent, canActivate: [RouteGuard] },
  { path: 'no-trip-home', component: NoTripHomeComponent, canActivate: [RouteGuard] },
  { path: 'active-trip-home', component: ActiveTripHomeComponent, canActivate: [RouteGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [RouteGuard] },
  { path: 'records-page', component: RecordsPageComponent, canActivate: [RouteGuard] },
  { path: 'fishery-notices', component: FisheryNoticesComponent, canActivate: [RouteGuard] },
  { path: 'lost-recovered-gear-form/:id', component: LostRecoveredGearFormComponent, canActivate: [RouteGuard] },
  { path: 'species-at-risk-report/:id', component: SpeciesAtRiskReportComponent, canActivate: [RouteGuard] },
  { path: 'marine-mammal-interaction-form/:id', component: MarineMammalInteractionFormComponent, canActivate: [RouteGuard] },
  { path: 'admin-panel', component: AdminPanelComponent, canActivate: [RouteGuard]},
  { path: 'dev', component: DevComponent } // only used for development purposes
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: false })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
